"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SDKError extends Error {
    constructor(code, packageName, message) {
        super(message);
        this.name = 'SDKError';
        this.code = code;
        this.packageName = packageName;
        this.message = message;
    }
    toString() {
        return `${this.name} in ${this.packageName}: ${this.code}, ${this.message}`;
    }
    toJSON() {
        return {
            code: this.code,
            message: this.message,
            name: this.name,
            packageName: this.packageName,
        };
    }
}
exports.SDKError = SDKError;
//# sourceMappingURL=SDKError.js.map